import React from 'react';

const SvgHelpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.991 13.3791C12.8252 11.8733 14.4285 10.9849 15.3602 9.65242C16.346 8.25492 15.7935 5.64409 12.9985 5.64409C11.1677 5.64409 10.2685 7.03075 9.88933 8.17909L7.0835 6.99825C7.85266 4.69075 9.9435 2.70825 12.9877 2.70825C15.5335 2.70825 17.2777 3.86742 18.166 5.31908C18.9243 6.56492 19.3685 8.89409 18.1985 10.6274C16.8985 12.5449 15.6527 13.1299 14.981 14.3649C14.7102 14.8633 14.6018 15.1883 14.6018 16.7916H11.471C11.4602 15.9466 11.3302 14.5708 11.991 13.3791ZM15.1652 21.1249C15.1652 22.3166 14.1902 23.2916 12.9985 23.2916C11.8068 23.2916 10.8318 22.3166 10.8318 21.1249C10.8318 19.9333 11.8068 18.9583 12.9985 18.9583C14.1902 18.9583 15.1652 19.9333 15.1652 21.1249Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgHelpIcon;
